import styles from "../landing-page-mobile-one.module.css";
import { usePaths } from "BEDROCK/paths";
import { useAnalyticsTracker } from "analytics-tracker";

export const FooterSectionMobile = () => {
  const { navigateTo, terms, privacyPolicy, cookiePolicy } = usePaths();
  const { trackEvent } = useAnalyticsTracker();

  const goTo = (path: string, linkName: string) => {
    trackEvent("Mobile landing footer link clicked", { link: linkName });
    navigateTo(path);
  };

  const handleExternalLink = (linkName: string) => {
    trackEvent("Mobile landing footer link clicked", { link: linkName });
  };

  return (
    <footer className={styles.footerMobile}>
      <div className={styles.footerLinksMobile}>
        <FooterLink
          title="FAQ"
          url="https://articles.trailart.store/FAQ"
          onExternalClick={() => handleExternalLink("faq")}
        />
        <FooterLink title="Terms & Conditions" onClick={() => goTo(terms, "terms")} />
        <FooterLink
          title="Privacy Policy"
          onClick={() => goTo(privacyPolicy, "privacy_policy")}
        />
        <FooterLink title="Cookie Policy" onClick={() => goTo(cookiePolicy, "cookie_policy")} />
        <FooterLink
          title="Contact Us"
          onClick={() => {
            trackEvent("Mobile landing footer link clicked", { link: "contact_us" });
            window.open("mailto:support@trailart.store", "_blank");
          }}
        />
      </div>
      <div className={styles.footerSocialMobile}>
        <a
          href="https://www.instagram.com/_trailart_/"
          className={styles.instaButtonMobile}
          target="_blank"
          rel="noreferrer"
          onClick={() => handleExternalLink("instagram")}
        >
          <img
            src="/landing-page/shared/insta-qr-3.png"
            alt="Follow us on Instagram"
          />
        </a>
      </div>
    </footer>
  );
};

interface FooterLinkProps {
  title: string;
  url?: string;
  onClick?: () => void;
  onExternalClick?: () => void;
}

const FooterLink = (props: FooterLinkProps) => {
  if (props.url) {
    return (
      <a
        className={styles.footerLinkMobile}
        href={props.url}
        target="_blank"
        rel="noreferrer"
        onClick={props.onExternalClick}
      >
        {props.title}
      </a>
    );
  }

  return (
    <button className={styles.footerLinkMobile} onClick={props.onClick}>
      {props.title}
    </button>
  );
};
